import BankAccountsCard from "./BankAccountsCard"

export default BankAccountsCard
